"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const cell_1 = require("./cell");
const text_1 = require("../simpleGrid/text");
const react_rxk_1 = require("react-rxk");
class GridCell extends React.PureComponent {
    render() {
        const { view, data, string, sharedValue, cellKey, onDrillDown } = this.props;
        const effectiveView = view || cell_1.defaultCellView;
        const effectiveString = text_1.getEffectiveString(data, string);
        const element = effectiveView(data, sharedValue, path => onDrillDown(cellKey, path), effectiveString);
        if (typeof element == "string") {
            return (React.createElement("div", { style: { overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } },
                React.createElement("span", null, element)));
        }
        else {
            return element;
        }
    }
}
/**Una fila del grid */
class GridRow extends React.PureComponent {
    render() {
        const props = this.props;
        return (React.createElement("tr", null, props.columns.map(x => ({ data: props.value.cell[x.key || x.title], title: x.title, key: x.key })).map(x => React.createElement("td", { key: x.key, style: x.data.style && x.data.style(props.sharedValue) },
            React.createElement(react_rxk_1.Rx, { render: GridCell, props: {
                    cellKey: x.key,
                    data: x.data.data,
                    view: x.data.view,
                    sharedValue: props.sharedValue,
                    onDrillDown: props.onDrillDown,
                    string: x.data.string,
                } })))));
    }
}
exports.GridRow = GridRow;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/row.js
// module id = 2226
// module chunks = 0